import Vue          from 'vue'
import Vuex         from 'vuex'
import mapActions   from './mapActions'
import { http }     from './mapActions'
import { server }   from './mapActions'

const store = {
  state: {
    server,
    connectionOk: null,
    connectionError: null,
    loading: false,
    lastRequestStatus: null,
    lastRequestError: null,
    lastRequestSuccess: null,
    helpMessage: null,
    helpTimeout: 10000,
    _help: 0,
    events: [],
    certificate: null,
    question: null 
  }
}

mapActions(store, {
  connectionStatusChange: ({ commit }, { ok, error }) => {
    // console.warn({ ok, error })
    commit('function', state => {
      state.connectionOk = ok
      state.connectionError = error
    })
  },
  
  startRequest: ({ commit, dispatch, state }) => {
    if(!state.connectionOk) dispatch('connectionStatusChange', { ok: true })

    commit('function', state => {
      state.loading = true
      // state.lastRequestStatus = null
      // state.lastRequestError = null
      // state.lastRequestSuccess = null
    })
  },

  endRequest: ({ commit }, { status, error, success }) => {
    // console.warn({ status, error, success })

    commit('function', state => {
      state.loading = false
      if(status) {
        state.lastRequestStatus = status
        state.lastRequestError = error
        state.lastRequestSuccess = success
      }
    })

    if(status) {
      window.setTimeout(() => {
        commit('function', state => {
          state.lastRequestStatus = null
          state.lastRequestError = null
          state.lastRequestSuccess = null
        })
      }, 4000)
    }
  },

  showHelp: ({ commit }, message) => {
    commit('function', state => {
      state.helpMessage = message
      state._help = window.setTimeout(
        () => state.helpMessage = null,
        state.helpTimeout
      )
    })    
  },

  hiddeHelp: ({ commit }) => {
    commit('function', state => {
      state.helpMessage = null
      window.clearTimeout(state._help)
    })
  },

  getQuestion: ({ commit }) => 
    http.get('/question')
    .then(({ data }) => commit('function', state => state.question = data)),

  getAllEvents: ({ commit }) => 
    http.get('/events')
    .then(({ data }) => commit('function', state => state.events = data)),

  issueCertificate: ({ commit }, { eventId, name, email, answer }) => 
    http.post(`/certificate/${eventId}`, new URLSearchParams({ name, email, answer }))
    .then(({ data }) => commit('function', state => state.certificate = data.certificate)),
})

Vue.use(Vuex)

export default new Vuex.Store(store)